import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Form, notification, Select, Spin, Input, Button, PageHeader  } from 'antd';
import '../../styles/components/MarketPlace/AdditionalDetails.scss';
import BottomButton from '../Buttons/BottomButton';
import {
  updateMarketplaceUserDetails,
  getUserDetailsById,
} from '../../services/API/MarketplaceService';
import { Routes } from '../../constants/RouterConstants';
import { Navigation } from '../../services/NavigationService';
import {
  forceUpdateVersion,
  qualificationsTranslationsMap,
  salaryRangeMap,
} from '../../constants/MarketplaceConstants';
import useMoengage from '../../hooks/useMoengage';
import { useMitraDispatch, useMitraStore } from '../../contexts/MitraContext';
import moment from 'moment';
// import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';
// import blitz from 'blitzllama-js';
import LanguageSelectionDrawer from './popups/LanguageSelectionDrawer';
import ForceUpdatePopup from './popups/ForceUpdatePopup';

const { Option } = Select;

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const AdditionalDetails = () => {
  const [loading, setLoading] = useState(true);
  const query = useQuery();
  const userId = query.get('userId');
  const navigateTo = query.get('navigateTo');
  const company = query.get('company');
  const { actions: MitraActions } = useMitraDispatch();
  const { fetchMarketplaceMitraDetails } = MitraActions;
  const { selectedMitraDetails } = useMitraStore();
  const [createMoengageUser, trackEvent] = useMoengage();
  const [form] = Form.useForm();
  const [qualification, setQualification] = useState('');
  const [salaryRange, setSalaryRange] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const {t, i18n} = useTranslation();
  const history = useHistory();
  const [isLanguageSelectionDrawerVisible, setLanguageSelectionDrawerVisibility] = useState(false);
  const [userName, setName] = useState('');
  const [showForceUpdatePopup, setShowForceUpdatePopup] = useState(false);
  
  const appVersion = parseInt(query.get('appVersion'));
  if (appVersion) localStorage.setItem("appVersion", appVersion);

  const updateGoogleAnalyticsId = (googleAnalyticsClientId) => {
    updateMarketplaceUserDetails({
      userId,
      dataToUpdate: {
        googleAnalyticsClientId
      },
    }).catch(error => {
      console.log(error);
    });

  }

  useEffect(() => {
    if (appVersion && appVersion < forceUpdateVersion) {
      setShowForceUpdatePopup(true);
      setLoading(false);
      return;
    } 
    setLoading(true);
    localStorage.setItem('userId', userId);
    // ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID, { siteSpeedSampleRate: 100 });
    // ReactGA.ga((tracker) => {
    //   const googleAnalyticsClientId = tracker.get('clientId');
    //   if (googleAnalyticsClientId) {
    //     updateGoogleAnalyticsId(googleAnalyticsClientId);
    //   }
    // });
    fetchMarketplaceMitraDetails(userId);
    getUserDetailsById(userId)
      .then(response => {
        if (response?.status === 200) {
          return response?.data;
        }
      })
      .then(responseObj => {
        // setting username
        if (responseObj.firstName && responseObj.lastName) {
          if(responseObj.lastName.toLowerCase() === 'unknown') {
            if (responseObj.firstName !== 'firstName') {
              setName(responseObj.firstName);
              setFirstname(responseObj.firstName);
            }
          } else {
            let tempName = '';
            if (responseObj.firstName !== 'firstName') {
              tempName += responseObj.firstName;
            }
            if (responseObj.lastName !== 'lastName') {
              tempName += ' ' +responseObj.lastName;
            }
            setName(tempName);
            setFirstname(tempName);
          }
        }

        // setting language preference
        responseObj.preferredLanguage ? i18n.changeLanguage(responseObj.preferredLanguage): i18n.changeLanguage('en');
        localStorage.setItem('preferredLanguage', responseObj.preferredLanguage ? responseObj.preferredLanguage: 'en');

        // creating moengage user instance
        createMoengageUser(responseObj.userId, responseObj.firstName, responseObj.userPhoneNumber);
        // blitz.createUser(responseObj.userId);

        if (responseObj?.educationalQualification && responseObj?.expectedSalary) {
          if (responseObj?.jobseekerCityPreference) {
            localStorage.setItem('preferredLocation', responseObj?.jobseekerCityPreference);

            // if the route is for notification deeplink, navigate to NotificationDeeplinkManagement.js
            if (company && navigateTo) {
              history.replace(`/notifications?navigateTo=${navigateTo}&company=${company}`);
            } else {
              const jobListingsRoute = {
                pathname: Routes.JOB_LISTINGS,
                search: `city=${responseObj?.jobseekerCityPreference}`,
              };
              Navigation.push(jobListingsRoute);
            }
            setLoading(false);
          } else {
            const citySelectionRoute = {
              pathname: Routes.SELECT_CITY_WISE_JOBS,
            };
            Navigation.push(citySelectionRoute);
          }
        } else setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  }, [userId]);

  const handleSubmit = () => {
      if (firstname === '') {
        notification.error({
          message: t('firstname_error'),
        });
        return;
      }
      // if (lastname === '') {
      //   notification.error({
      //     message: t('lastname_error'),
      //   });
      //   return;
      // }
      if (qualification === '') {
        notification.error({
          message: t('qualification_error'),
        });
        return;
      }

      if (salaryRange === '') {
        notification.error({
          message: t('salary_range_error'),
        });
        return;
      }

      localStorage.setItem('userId', userId);

      trackEvent('jse_initial_details_submission', 
      { 
        userId: localStorage.getItem('userId'), 
        userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
        timeStamp: moment().format('MM/DD/YYYY HH:mm:ss') 
      }
      );

      updateMarketplaceUserDetails({
        userId,
        dataToUpdate: {
          educationalQualification: qualification,
          expectedSalary: salaryRange,
          name: `${firstname}`
        },
      })
      .then(res=> {
        if (res.data.name !== '200') {
          notification.error({
            message: 'Please enter correct name !',
          });
        } else {
          const route = {
            pathname: Routes.SELECT_CITY_WISE_JOBS,
          };
          Navigation.push(route);
        }
      })
      .catch(error => {
        console.log(error);
      });
};

  return !loading ? (
    <>
    <LanguageSelectionDrawer 
    isLanguageSelectionDrawerVisible={isLanguageSelectionDrawerVisible}
    setLanguageSelectionDrawerVisibility={setLanguageSelectionDrawerVisibility}
    />
      <PageHeader
        className="site-page-header"
        title={t('additional_details')}
        extra={[
          <Button style={{border:'none'}} onClick={()=>setLanguageSelectionDrawerVisibility(true)}><img src='/images/lang.png' style={{width:'30px'}}/></Button>
        ]}
      />
      <div className="mainContainer">
      
      {/* <h5 className="mainHeading">{t('additional_details')}</h5> */}
      <p className="shareDetailsHeadingLarge">{t('share_details')}</p>
      <p className="shareDetailsHeadingSmall">{t('find_best_job')}</p>
      
      {/* Form Starts */}
      <Form form={form} layout="vertical" autoComplete="off" className="formContainer">
        <Form.Item
        label="Your Name"
        name="fname"
        rules={[{ required: true, message: t('firstname_error') }]}
        >
          <Input onChange={(e)=> setFirstname(e.target.value)} className="form-input" defaultValue={userName}/>
        </Form.Item>
        {/* <Form.Item
        label="Lastname"
        name="lname"
        rules={[{ required: true, message: t('lastname_error') }]}
        >
          <Input onChange={(e)=> setLastname(e.target.value)} />
        </Form.Item> */}
        <Form.Item
          name="educationQualifications"
          label="Education Qualification"
          className="formHeading"
          rules={[
            {
              required: true,
              message: t('qualification_error'),
            },
          ]}
        >
          <Select
            placeholder={t('choose_qualification')}
            className="formSelect"
            allowClear
            bordered={false}
            onChange={value => setQualification(value)}
          >
            {Object.entries(qualificationsTranslationsMap).map(([k, v]) => (
              <Option value={v} key={k}>
                {v}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="salaryRange"
          label="Expected Salary (Per month)"
          className="formHeading"
          rules={[
            {
              required: true,
              message: t('salary_range_error')
            },
          ]}
        >
          <Select
            placeholder={t('salary_range')}
            className="formSelect"
            allowClear
            bordered={false}
            onChange={value => setSalaryRange(value)}
          >
            {Object.entries(salaryRangeMap).map(([k, v]) => (
              <Option value={v} key={k}>
                {v}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <BottomButton buttonText="Next" callBackFunction={() => handleSubmit()} />
      </Form>
      {/* Form Ends */}

    </div>
    <ForceUpdatePopup
        open={showForceUpdatePopup}
        close={() => setShowForceUpdatePopup(false)}
      />
    </>
    
  ) : (
    <Spin spinning={loading} className="spinner" tip="Loading" />
  );
};

export default AdditionalDetails;
